<template>
  <div class="nd-choose">
    <van-popup
      v-model="visible"
      position="bottom"
    >
      <div class="nd-choose-popup">
        <div class="nd-choose-toolbar">
          <span>{{ title || label }}</span>
          <img src="./images/close.png" @click="visible = false">
        </div>

        <div class="nd-choose-list" ref="list">
          <div class="nd-choose-item"
               :class="{ 'nd-choose-item_active': index === selectItemIdx,disabled: item.disable==='Y' }"
               v-for="(item, index) in pickerData"
               :key="index"
               @click="selectItem(item)"
          >
            {{ item.name }}
          </div>
        </div>

        <div class="nd-choose-bottom"></div>
      </div>
    </van-popup>

    <div class="nd-inner-input" @click="clickHandler">
      <input
        type="text"
        class="nd-choose-text"
        :class="textAlign"
        :placeholder="placeholder"
        :readonly="readonly"
        :disabled="!editable"
        :value="bindText && showFormatter(bindText)"
        :name="name"
        ref="input"
      >
      <slot><label :for="name" v-if="label">{{ label }}</label></slot>
      <i class="arrow-icon"></i>
      <input 
        type="hidden"
        :value="currentValue"
      >
    </div>
  </div>
</template>
<script>
import { Popup } from 'vant'
export default {
  name: 'nd-choose',

  components: {
    'van-popup': Popup
  },

  data () {
    return {
      currentValue: this.value,
      bindText: '',
      visible: false,
      selectItemIdx: -1
    }
  },

  props: {
    type: {
      type: String,
      default: 'text'
    },
    name: String,
    placeholder: {
      type: String,
      default: '请选择'
    },
    size: {
      type: Number,
      default: 5
    },
    label: String,
    // eslint-disable-next-line vue/require-prop-type-constructor
    value: String | Number,
    data: Array,
    editable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: true
    },
    title: String,
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    showToolbar: {
      type: Boolean,
      default: true
    },
    textAlign: {
      type: String,
      default: 'right'
    },
    valueKey: {
      type: Array,
      default: () => ['value', 'name']
    },
    mutilple: Boolean,
    showFormatter: {
      type: Function,
      default: format => format
    },
    beforeClick: {
      type: Function,
      default: () => {
        return Promise.resolve(true)
      }
    }
  },

  watch: {
    value (val) {
      this.setCurrentValue(val)
    },

    bindValue (val) {
      this.setCurrentValue(val)
    },

    visible (val) {
      if (val) {
        this.$emit('open')
      } else {
        this.$emit('close')
      }
    }
  },

  created () {
    if (this.data && this.data.length) {
      this.setInitText(this.value, this.data)
    } else {
      this.$watch('data', (list) => {
        this.setInitText(this.value, list)
      })
      this.$watch('value', (value) => {
        this.setInitText(value, this.data)
      })
    }
  },

  computed: {
    pickerData () {
      if (this.data && this.data.length > 0) {
        return this.data.map(item => {
          return {
            name: item[this.valueKey[1]],
            value: item[this.valueKey[0]],
            disable: item.disable,
            item
          }
        })
      }
      return []
    }
  },

  methods: {
    setCurrentValue (value) {
      if (value === this.currentValue) return
      this.$emit('input', value)
      this.$refs['input'].dispatchEvent(new Event('input'))
      this.$refs['input'].dispatchEvent(new Event('change'))
      this.currentValue = value
      this.bindValue = value
      if (value === '') {
        this.currentValue = value
        this.bindText = ''
      } else {
        this.setInitText(value, this.data)
      }
    },

    // 设置初始化显示文本
    setInitText (value, list) {
      if (list && list instanceof Array) {
        let item = list.filter(item => item[this.valueKey[0]] === value)[0]
        this.bindText = item && item[this.valueKey[1]]
      }
    },

    clickHandler () {
      this.beforeClick().then(open => {
        if (open) {
          this.visible = true
        }
        this.$emit('click')
        this.$nextTick(() => {
          // fix:使picker选中目前select选中的值
          let idx = -1
          this.pickerData.forEach((item, index) => {
            if (item.value === this.value) {
              idx = index
            }
          })
          this.selectItemIdx = idx
        })
      })
    },

    selectItem (item) {
      if (item.disable === 'Y') {
        return
      }
      if (this.bindText !== item.name) {
        this.$emit('change', item, this.name)
      }
      this.setCurrentValue(item.value)
      this.visible = false
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

    .nd-choose {
        position: relative;
        height: 100%;
        width: 100%;

        .nd-inner-input {
            display: flex;
            align-items: center;
            height: 100%;
            width: 100%;
            position: relative;
        }

        input {
            border: none;
            outline: none;
            width: 100%;
            height: 100%;
            color: @fc1;
            font-size: 28px;
            background: transparent;
            font-family: 'PingFangSC-Regular';
            font-weight: 400;
            pointer-events: none;
            &.nd-choose-text {
                padding-right: 20px;
                &.right {
                    text-align: right;
                }
                &.center {
                    text-align: center;
                }
            }
            &::-moz-placeholder { color: @fc4; -webkit-text-fill-color: @fc4;}
            &:-moz-placeholder { color: @fc4; -webkit-text-fill-color: @fc4;}
            &::-webkit-input-placeholder { color: @fc4; -webkit-text-fill-color: @fc4;}
            &:-ms-input-placeholder { color:@fc4; -webkit-text-fill-color: @fc4;}
            &[disabled], &:disabled, &.disabled {
                background-color: transparent;
                color: @fc1!important;
                -webkit-text-fill-color: @fc1;
                -webkit-opacity: 1;
                opacity: 1;
            }
        }

        label {
            position: absolute;
            height: 100%;
            left: 0;
            top: 0;
            font-size: 30px;
            background-color: #fff;
            font-family: 'PingFangSC-Regular';
            font-weight: 400;
        }

        .arrow-icon {
            position: absolute;
            top: 50%;
            right: 0;
            height: 20px;
            margin-top: -10px;
            width: 11px;
            background-image: url(../nd-cell/images/arrow.png);
            background-size: 100% 100%;
            display: block;
        }

        .van-popup {
            border-radius: 30px 30px 0px 0px;
            overflow: hidden;

            .nd-choose-popup {
                .nd-choose-toolbar {
                    height: 170px;
                    box-sizing: border-box;
                    padding: 65px 50px 55px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 1px solid #EEEEEE;

                    span {
                        font-size: 36px;
                        font-family: PingFangSC-Medium,PingFang SC;
                        font-weight: 500;
                        color: @fc1;
                    }

                    img {
                        width: 33px;
                        height: 33px;
                    }
                }

                .nd-choose-list {
                    overflow: auto;
                    max-height: 770px;

                    .nd-choose-item {
                        height: 110px;
                        line-height: 110px;
                        font-size: 30px;
                        font-family: PingFangSC-Regular,PingFang SC;
                        font-weight: 400;
                        color: @fc1;
                        padding: 0 50px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        border-bottom: 1px solid #EEEEEE;
                        box-sizing: border-box;
                        &.disabled{
                          color: #999;
                        }
                        &_active {
                            background-color: #FAFAFA;
                        }
                    }
                }

                .nd-choose-bottom {
                    height: 80px;
                }
            }
        }
    }
</style>